export enum VisualizationTimePeriod {
	Current = 'current',
	Previous = 'previous'
}
